import { observer } from 'mobx-react';
import React from 'react';
import TableToolbar from '../../shared/tableToolbar';
import AMAAftercareRuleStore from './Store';
import * as api from '../../../stores/api';
import dashboardStore from '@stores/dashboard';

@observer
class AMAAftercareRuleToolbar extends React.Component {
  handleSearchChange = (_, { value }) => {
    AMAAftercareRuleStore.setFieldsValue({ keyword: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    AMAAftercareRuleStore.refetch({}, true);
  };

  handleReset = () => {
    AMAAftercareRuleStore.resetStore();
  };

  handleCreate = () => {
    localStorage.removeItem('FundingAgreement');
    dashboardStore.close('/view/add-edit-funding-request');
    return setTimeout(() => {
      dashboardStore.open(`/view/add-edit-funding-request?id=${0}`);
    });
  };

  render() {
    const { keyword, loading } = AMAAftercareRuleStore;
    return (
      <TableToolbar.Container>
        <TableToolbar.Left onSubmit={this.handleSubmit}>
          <TableToolbar.Input
            placeholder="Search"
            value={keyword}
            onChange={this.handleSearchChange}
            disabled={loading}
          />
          <TableToolbar.SubmitButton disabled={loading}>Search</TableToolbar.SubmitButton>
          <TableToolbar.HighLightButton
            className="negative"
            disabled={loading}
            onClick={this.handleReset}
            style={{ marginLeft: '5px' }}
          >
            Clear
          </TableToolbar.HighLightButton>
        </TableToolbar.Left>
        <TableToolbar.Right>
          {api.isAdminOrMagStaffOrAccounting() && !api.isOnlySearch() && (
            <TableToolbar.HighLightButton className="positive" disabled={loading} onClick={this.handleCreate}>
              Add New
            </TableToolbar.HighLightButton>
          )}
        </TableToolbar.Right>
      </TableToolbar.Container>
    );
  }
}

export default AMAAftercareRuleToolbar;
